<template>
    <div class="flex items-center relative">
        <div class="parent relative status-circle">
            <span :class="data.status" class="label rounded-full inline-block text-sm font-bold" style="padding: .4rem .7rem;">
                {{  data.status  }}
            </span>
        </div>
        
    </div>

</template>

<script>

/* Note, this was copied / renamed from MessageTableStatus. So we can just update the Sent Message Table first */

export default {
    name: "MessageSentTableStatus",
    props: {
        meta: {
            type: Object,
            default: () => {}
        },
        name: {
            type: String,
            default: ""
        },
        data: {
            type: Object,
            default: () => {}
        },
    },
    components: { },
    data: () => ({
    }),
    computed: {

   },
    mounted() {

    },
    methods: {},
};
</script>

<style scoped lang="scss">

.status-circle {
    line-height: 12px;
}
span.label {
    text-transform: capitalize;
    &.sending {
        @apply bg-blue-200;
        @apply text-blue-800;
    }
    &.sent {
        @apply bg-green-200;
        @apply text-green-800;
    }
    &.failed{
        @apply bg-red-200;
        @apply text-red-800;
    }
}
</style>
